import { HTMLAttributes, ReactElement, forwardRef } from 'react';

import styled from 'styled-components';

import { IconProps } from '@components/icons';
import { theme } from '@styles/theme';
import { pxToRem } from '@utils/converters';

export type IconContainerSize = 'small' | 'medium' | 'large';

const SIZE_MAP: Record<IconContainerSize, number> = {
  small: 24,
  medium: 32,
  large: 40,
};

export type IconContainerProps = {
  icon: ReactElement<IconProps>;
  size?: IconContainerSize;
} & HTMLAttributes<HTMLDivElement>;

export const IconContainer = forwardRef<HTMLDivElement, IconContainerProps>(
  ({ icon, size = 'medium', ...rest }, ref) => {
    return (
      <StyledContainer ref={ref} $size={size} {...rest}>
        {icon}
      </StyledContainer>
    );
  },
);

const StyledContainer = styled.div<{ $size: IconContainerSize }>(({ $size }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: pxToRem(SIZE_MAP[$size]),
  height: pxToRem(SIZE_MAP[$size]),
  borderRadius: pxToRem(4),
  backgroundColor: theme.color.backgroundLightDark,
  boxShadow: theme.shadow.low,
  flexShrink: 0,
}));
